import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  enabled: {
    id: 'documentType.enabled',
    description: 'Enabled',
    defaultMessage: 'Enabled',
  },
  newDocumentType: {
    id: 'documentType.newDocumentType',
    description: 'New Document Type',
    defaultMessage: 'New Document Type',
  },
  editDocumentType: {
    id: 'documentType.editDocumentType',
    description: 'Edit Document Type',
    defaultMessage: 'Edit Document Type',
  },
  documentTypeName: {
    id: 'documentType.documentTypeName',
    description: 'Document Type Name',
    defaultMessage: 'Document Type Name',
  },
  documentCategory: {
    id: 'documentType.documentCategory',
    description: 'Document Category',
    defaultMessage: 'Document Category',
  },
  cancelBtn: {
    id: 'documentType.cancelBtn',
    description: 'Cancel',
    defaultMessage: 'Cancel',
  },
  saveBtn: {
    id: 'documentType.saveBtn',
    description: 'Save',
    defaultMessage: 'Save',
  },
  createBtn: {
    id: 'documentType.createBtn',
    description: 'Create',
    defaultMessage: 'Create',
  },
  updateBtn: {
    id: 'documentType.updateBtn',
    description: 'Update',
    defaultMessage: 'Update',
  },
  editBtn: {
    id: 'documentType.editBtn',
    description: 'Edit',
    defaultMessage: 'Edit',
  },
  documentTypeCreated: {
    id: 'documentType.documentTypeCreated',
    description: 'Document type created successfully',
    defaultMessage: 'Document type created successfully',
  },
  documentTypeNotCreated: {
    id: 'documentType.documentTypeNotCreated',
    description: 'Failed to create document type',
    defaultMessage: 'Failed to create document type',
  },
  documentTypeUpdated: {
    id: 'documentType.documentTypeUpdated',
    description: 'Document type updated successfully',
    defaultMessage: 'Document type updated successfully',
  },
  documentTypeNotUpdated: {
    id: 'documentType.documentTypeNotUpdated',
    description: 'Failed to update document type',
    defaultMessage: 'Failed to update document type',
  },
  clear: {
    id: 'documentType.clear',
    description: 'Clear',
    defaultMessage: 'Clear',
  },
  clearSelection: {
    id: 'documentType.clearSelection',
    description: 'Clear Selection',
    defaultMessage: 'Clear Selection',
  },
  customer: {
    id: 'documentType.customer',
    description: 'Customer',
    defaultMessage: 'Customer',
  },
  noCustomersAvailable: {
    id: 'documentType.noCustomersAvailable',
    description: 'No customers available',
    defaultMessage: 'No customers available',
  },
  selectCustomer: {
    id: 'documentType.selectCustomer',
    description: 'Select customer',
    defaultMessage: 'Select customer',
  },
  noDocumentCategoriesAvailable: {
    id: 'documentType.noDocumentCategoriesAvailable',
    description: 'No document categories available',
    defaultMessage: 'No document categories available',
  },
  selectDocumentCategory: {
    id: 'documentType.selectDocumentCategory',
    description: 'Select document category',
    defaultMessage: 'Select document category',
  },
  systemDefined: {
    id: 'documentType.systemDefined',
    description: 'System Defined',
    defaultMessage: 'System Defined',
  },
  inUse: {
    id: 'documentType.inUse',
    description: 'In Use',
    defaultMessage: 'In Use',
  },
  documentTypeDeleted: {
    id: 'documentType.documentTypeDeleted',
    description: 'Document type deleted successfully',
    defaultMessage: 'Document type deleted successfully',
  },
  documentTypeNotDeleted: {
    id: 'documentType.documentTypeNotDeleted',
    description: 'Failed to delete document type',
    defaultMessage: 'Failed to delete document type',
  },
  deleteDocumentTypeTitle: {
    id: 'documentType.deleteDocumentTypeTitle',
    description: 'Delete Document Type',
    defaultMessage: 'Delete Document Type',
  },
  deleteDocumentTypeDescription: {
    id: 'documentType.deleteDocumentTypeDescription',
    description: 'Are you sure you want to delete this document type?',
    defaultMessage: 'Are you sure you want to delete this document type?',
  },
  deleteBtn: {
    id: 'documentType.deleteBtn',
    description: 'Delete',
    defaultMessage: 'Delete',
  },
})
